const autoNgTemplateLoaderTemplate1 = require('./views/sidebar/sidebar.html');
const autoNgTemplateLoaderTemplate2 = require('./views/account/account.html');
const autoNgTemplateLoaderTemplate3 = require('./views/auth/auth.html');
const autoNgTemplateLoaderTemplate4 = require('./views/logout/logout.html');
const autoNgTemplateLoaderTemplate5 = require('./views/endpoints/endpoints.html');
const autoNgTemplateLoaderTemplate6 = require('./views/endpoints/edit/endpoint.html');
const autoNgTemplateLoaderTemplate7 = require('../kubernetes/views/configure/configure.html');
const autoNgTemplateLoaderTemplate8 = require('./views/endpoints/create/createendpoint.html');
const autoNgTemplateLoaderTemplate9 = require('./views/endpoints/create/createendpoint.html');
const autoNgTemplateLoaderTemplate10 = require('./views/devices/import/importDevice.html');
const autoNgTemplateLoaderTemplate11 = require('./views/endpoints/access/endpointAccess.html');
const autoNgTemplateLoaderTemplate12 = require('./views/endpoints/kvm/endpointKVM.html');
const autoNgTemplateLoaderTemplate13 = require('./views/groups/groups.html');
const autoNgTemplateLoaderTemplate14 = require('./views/groups/edit/group.html');
const autoNgTemplateLoaderTemplate15 = require('./views/groups/create/creategroup.html');
const autoNgTemplateLoaderTemplate16 = require('./views/groups/access/groupAccess.html');
const autoNgTemplateLoaderTemplate17 = require('./views/home/home.html');
const autoNgTemplateLoaderTemplate18 = require('./views/init/endpoint/initEndpoint.html');
const autoNgTemplateLoaderTemplate19 = require('./views/init/admin/initAdmin.html');
const autoNgTemplateLoaderTemplate20 = require('./views/projects/projects.html');
const autoNgTemplateLoaderTemplate21 = require('./views/projects/edit/project.html');
const autoNgTemplateLoaderTemplate22 = require('./views/projects/create/createProject.html');
const autoNgTemplateLoaderTemplate23 = require('./views/registries/registries.html');
const autoNgTemplateLoaderTemplate24 = require('./views/registries/edit/registry.html');
const autoNgTemplateLoaderTemplate25 = require('./views/settings/settings.html');
const autoNgTemplateLoaderTemplate26 = require('./views/settings/authentication/settingsAuthentication.html');
const autoNgTemplateLoaderTemplate27 = require('./views/tags/tags.html');
const autoNgTemplateLoaderTemplate28 = require('./views/users/users.html');
const autoNgTemplateLoaderTemplate29 = require('./views/users/edit/user.html');
const autoNgTemplateLoaderTemplate30 = require('./views/teams/teams.html');
const autoNgTemplateLoaderTemplate31 = require('./views/teams/edit/team.html');

import _ from 'lodash-es';

import footerModule from '@/shbdeployer/components/footer';
import helpModule from '@/shbdeployer/components/help';
import pagesModule from '@/shbdeployer/pages';

import './rbac';
import componentsModule from './components';
import settingsModule from './settings';
import featureFlagModule from './feature-flags';
import auditLogModule from './audit-log';
import servicesModule from './services';
import teamsModule from './teams';

async function initAuthentication(authManager, Authentication, $rootScope, $state) {
  authManager.checkAuthOnRefresh();
  // The unauthenticated event is broadcasted by the jwtInterceptor when
  // hitting a 401. We're using this instead of the usual combination of
  // authManager.redirectWhenUnauthenticated() + unauthenticatedRedirector
  // to have more controls on which URL should trigger the unauthenticated state.
  $rootScope.$on('unauthenticated', function (event, data) {
    if (!_.includes(data.config.url, '/v2/') && !_.includes(data.config.url, '/api/v4/') && isTransitionRequiresAuthentication($state.transition)) {
      $state.go('shbdeployer.logout', { error: 'Сеанс истек. Войдите в систему повторно' });
    }
  });

  return await Authentication.init();
}

angular
  .module('shbdeployer.app', [
    'shbdeployer.oauth',
    'shbdeployer.rbac',
    componentsModule,
    settingsModule,
    featureFlagModule,
    auditLogModule,
    footerModule,
    pagesModule,
    helpModule,
    'shbdeployer.shared.datatable',
    servicesModule,
    teamsModule,
  ])
  .config(configureLegacyRedirects)
  .config([
    '$stateRegistryProvider',
    function ($stateRegistryProvider) {
      var root = {
        name: 'root',
        abstract: true,
        onEnter: /* @ngInject */ function onEnter($async, StateManager, Authentication, Notifications, authManager, $rootScope, $state) {
          return $async(async () => {
            const appState = StateManager.getState();
            if (!appState.loading) {
              return;
            }
            try {
              const loggedIn = await initAuthentication(authManager, Authentication, $rootScope, $state);
              await StateManager.initialize();
              if (!loggedIn && isTransitionRequiresAuthentication($state.transition)) {
                $state.go('shbdeployer.logout');
                return Promise.reject('Unauthenticated');
              }
            } catch (err) {
              Notifications.error('Ошибка', err, 'Не удалось получить настройки приложения');
              throw err;
            }
          });
        },
        views: {
          'sidebar@': {
            templateUrl: autoNgTemplateLoaderTemplate1,
            controller: 'SidebarController',
          },
        },
      };

      var endpointRoot = {
        name: 'endpoint',
        url: '/:endpointId',
        parent: 'root',
        abstract: true,
        resolve: {
          endpoint: /* @ngInject */ function endpoint($async, $state, $transition$, EndpointService, Notifications) {
            return $async(async () => {
              try {
                const endpointId = +$transition$.params().endpointId;

                const endpoint = await EndpointService.endpoint(endpointId);
                if ((endpoint.Type === 4 || endpoint.Type === 7) && !endpoint.EdgeID) {
                  $state.go('shbdeployer.endpoints.endpoint', { id: endpoint.Id });
                  return;
                }

                return endpoint;
              } catch (e) {
                Notifications.error('Не удалось загрузить окружение', e);
                $state.go('shbdeployer.home', {}, { reload: true });
                return;
              }
            });
          },
        },
      };

      var portainer = {
        name: 'shbdeployer',
        parent: 'root',
        abstract: true,
      };

      var account = {
        name: 'shbdeployer.account',
        url: '/account',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate2,
            controller: 'AccountController',
          },
        },
      };

      const tokenCreation = {
        name: 'shbdeployer.account.new-access-token',
        url: '/tokens/new',
        views: {
          'content@': {
            component: 'createUserAccessToken',
          },
        },
      };

      var authentication = {
        name: 'shbdeployer.auth',
        url: '/auth',
        params: {
          reload: false,
        },
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate3,
            controller: 'AuthenticationController',
            controllerAs: 'ctrl',
          },
          'sidebar@': {},
        },
      };
      const logout = {
        name: 'shbdeployer.logout',
        url: '/logout',
        params: {
          error: '',
          performApiLogout: false,
        },
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate4,
            controller: 'LogoutController',
            controllerAs: 'ctrl',
          },
          'sidebar@': {},
        },
      };

      var endpoints = {
        name: 'shbdeployer.endpoints',
        url: '/infrastructure/environments',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate5,
            controller: 'EndpointsController',
          },
        },
      };

      var endpoint = {
        name: 'shbdeployer.endpoints.endpoint',
        url: '/:id',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate6,
            controller: 'EndpointController',
          },
        },
      };

      var k8sendpoint = {
        name: 'shbdeployer.k8sendpoint',
        url: '/infrastructure/environments/:id',
      };

      const endpointKubernetesConfiguration = {
        name: 'shbdeployer.k8sendpoint.kubernetesConfig',
        url: '/configure',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate7,
            controller: 'KubernetesConfigureController',
            controllerAs: 'ctrl',
          },
        },
      };

      var endpointCreation = {
        name: 'shbdeployer.endpoints.new',
        url: '/new',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate8,
            controller: 'CreateEndpointController',
          },
        },
      };

      var edgeDeviceCreation = {
        name: 'shbdeployer.endpoints.newEdgeDevice',
        url: '/newEdgeDevice',
        params: {
          isEdgeDevice: true,
        },
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate9,
            controller: 'CreateEndpointController',
          },
        },
      };

      var deviceImport = {
        name: 'shbdeployer.endpoints.importDevice',
        url: '/device',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate10,
            controller: 'ImportDeviceController',
          },
        },
      };

      var addFDOProfile = {
        name: 'shbdeployer.endpoints.profile',
        url: '/profile',
        views: {
          'content@': {
            component: 'addProfileView',
          },
        },
      };

      var editFDOProfile = {
        name: 'shbdeployer.endpoints.profile.edit',
        url: '/:id',
        views: {
          'content@': {
            component: 'editProfileView',
          },
        },
      };

      var endpointAccess = {
        name: 'shbdeployer.endpoints.endpoint.access',
        url: '/access',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate11,
            controller: 'EndpointAccessController',
            controllerAs: 'ctrl',
          },
        },
      };

      var endpointKVM = {
        name: 'shbdeployer.endpoints.endpoint.kvm',
        url: '/kvm?deviceId&deviceName',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate12,
            controller: 'EndpointKVMController',
          },
        },
      };

      var groups = {
        name: 'shbdeployer.groups',
        url: '/infrastructure/environment-groups',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate13,
            controller: 'GroupsController',
          },
        },
      };

      var group = {
        name: 'shbdeployer.groups.group',
        url: '/:id',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate14,
            controller: 'GroupController',
          },
        },
      };

      var groupCreation = {
        name: 'shbdeployer.groups.new',
        url: '/new',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate15,
            controller: 'CreateGroupController',
          },
        },
      };

      var groupAccess = {
        name: 'shbdeployer.groups.group.access',
        url: '/access',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate16,
            controller: 'GroupAccessController',
          },
        },
      };

      var home = {
        name: 'shbdeployer.home',
        url: '/home',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate17,
            controller: 'HomeController',
          },
        },
      };

      var init = {
        name: 'shbdeployer.init',
        abstract: true,
        url: '/init',
        views: {
          'sidebar@': {},
        },
      };

      const wizard = {
        name: 'shbdeployer.wizard',
        url: '/wizard',
        views: {
          'content@': {
            component: 'wizardView',
          },
        },
      };

      const wizardEndpoints = {
        name: 'shbdeployer.wizard.endpoints',
        url: '/endpoints',
        views: {
          'content@': {
            component: 'wizardEndpoints',
          },
        },
      };

      var initEndpoint = {
        name: 'shbdeployer.init.endpoint',
        url: '/endpoint',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate18,
            controller: 'InitEndpointController',
            controllerAs: 'ctrl',
          },
        },
      };

      var initAdmin = {
        name: 'shbdeployer.init.admin',
        url: '/admin',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate19,
            controller: 'InitAdminController',
          },
        },
      };

      var projects = {
        name: 'shbdeployer.projects',
        url: '/projects',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate20,
            controller: 'ProjectsController',
          },
        },
      };

      var project = {
        name: 'shbdeployer.projects.project',
        url: '/:id',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate21,
            controller: 'ProjectController',
          },
        },
      };

      var projectCreation = {
        name: 'shbdeployer.projects.new',
        url: '/new',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate22,
            controller: 'CreateProjectController',
          },
        },
      };

      var registries = {
        name: 'shbdeployer.registries',
        url: '/infrastructure/registries',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate23,
            controller: 'RegistriesController',
          },
        },
      };

      var registry = {
        name: 'shbdeployer.registries.registry',
        url: '/:id',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate24,
            controller: 'RegistryController',
          },
        },
      };

      const registryCreation = {
        name: 'shbdeployer.registries.new',
        url: '/new',
        views: {
          'content@': {
            component: 'createRegistry',
          },
        },
      };

      var settings = {
        name: 'shbdeployer.settings',
        url: '/administration/settings',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate25,
            controller: 'SettingsController',
          },
        },
      };

      var settingsAuthentication = {
        name: 'shbdeployer.settings.authentication',
        url: '/auth',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate26,
            controller: 'SettingsAuthenticationController',
          },
        },
      };

      var settingsEdgeCompute = {
        name: 'shbdeployer.settings.edgeCompute',
        url: '/edge',
        views: {
          'content@': {
            component: 'settingsEdgeComputeView',
          },
        },
      };

      var tags = {
        name: 'shbdeployer.tags',
        url: '/infrastructure/tags',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate27,
            controller: 'TagsController',
          },
        },
      };

      var users = {
        name: 'shbdeployer.users',
        url: '/administration/users',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate28,
            controller: 'UsersController',
          },
        },
      };

      var user = {
        name: 'shbdeployer.users.user',
        url: '/:id',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate29,
            controller: 'UserController',
          },
        },
      };

      var teams = {
        name: 'shbdeployer.teams',
        url: '/administration/teams',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate30,
            controller: 'TeamsController',
          },
        },
      };

      var team = {
        name: 'shbdeployer.teams.team',
        url: '/:id',
        views: {
          'content@': {
            templateUrl: autoNgTemplateLoaderTemplate31,
            controller: 'TeamController',
          },
        },
      };

      $stateRegistryProvider.register(root);
      $stateRegistryProvider.register(endpointRoot);
      $stateRegistryProvider.register(portainer);
      $stateRegistryProvider.register(account);
      $stateRegistryProvider.register(tokenCreation);
      $stateRegistryProvider.register(authentication);
      $stateRegistryProvider.register(logout);
      $stateRegistryProvider.register(endpoints);
      $stateRegistryProvider.register(endpoint);
      $stateRegistryProvider.register(k8sendpoint);
      $stateRegistryProvider.register(endpointAccess);
      $stateRegistryProvider.register(endpointKVM);
      $stateRegistryProvider.register(edgeDeviceCreation);
      $stateRegistryProvider.register(endpointCreation);
      $stateRegistryProvider.register(deviceImport);
      $stateRegistryProvider.register(addFDOProfile);
      $stateRegistryProvider.register(editFDOProfile);
      $stateRegistryProvider.register(endpointKubernetesConfiguration);
      $stateRegistryProvider.register(groups);
      $stateRegistryProvider.register(group);
      $stateRegistryProvider.register(groupAccess);
      $stateRegistryProvider.register(groupCreation);
      $stateRegistryProvider.register(home);
      $stateRegistryProvider.register(init);
      $stateRegistryProvider.register(wizard);
      $stateRegistryProvider.register(wizardEndpoints);
      $stateRegistryProvider.register(initEndpoint);
      $stateRegistryProvider.register(initAdmin);
      $stateRegistryProvider.register(projects);
      $stateRegistryProvider.register(project);
      $stateRegistryProvider.register(projectCreation);
      $stateRegistryProvider.register(registries);
      $stateRegistryProvider.register(registry);
      $stateRegistryProvider.register(registryCreation);
      $stateRegistryProvider.register(settings);
      $stateRegistryProvider.register(settingsAuthentication);
      $stateRegistryProvider.register(settingsEdgeCompute);
      $stateRegistryProvider.register(tags);
      $stateRegistryProvider.register(users);
      $stateRegistryProvider.register(user);
      $stateRegistryProvider.register(teams);
      $stateRegistryProvider.register(team);
    },
  ]);

/**
 * Совместимость со старыми URL: прежние адреса разделов перенаправляются на новую структуру
 * (/administration/*, /infrastructure/*), чтобы внешние ссылки и закладки продолжали работать.
 */
export const LEGACY_REDIRECTS = [
  ['/users', '/administration/users'],
  ['/users/:id', '/administration/users/:id'],
  ['/teams', '/administration/teams'],
  ['/teams/:id', '/administration/teams/:id'],
  ['/roles', '/administration/roles'],
  ['/settings', '/administration/settings'],
  ['/settings/auth', '/administration/settings/auth'],
  ['/settings/edge', '/administration/settings/edge'],
  ['/activity-logs', '/administration/audit-log'],
  ['/auth-logs', '/administration/audit-log'],
  ['/endpoints', '/infrastructure/environments'],
  ['/endpoints/new', '/infrastructure/environments/new'],
  ['/endpoints/:id', '/infrastructure/environments/:id'],
  ['/endpoints/:id/access', '/infrastructure/environments/:id/access'],
  ['/groups', '/infrastructure/environment-groups'],
  ['/groups/new', '/infrastructure/environment-groups/new'],
  ['/groups/:id', '/infrastructure/environment-groups/:id'],
  ['/groups/:id/access', '/infrastructure/environment-groups/:id/access'],
  ['/tags', '/infrastructure/tags'],
  ['/registries', '/infrastructure/registries'],
  ['/registries/new', '/infrastructure/registries/new'],
  ['/registries/:id', '/infrastructure/registries/:id'],
];

/**
 * Собирает новый адрес из шаблона, параметров маршрута и строки запроса.
 *
 * Строковый обработчик ui-router формирует адрес только из параметров, объявленных
 * в шаблоне маршрута, поэтому произвольная строка запроса теряется. Функция ниже
 * подставляет идентификаторы объектов и переносит все параметры запроса без изменений,
 * чтобы сохранённые ссылки с фильтрами и вкладками продолжали работать.
 */
export function legacyRedirectTarget(target, params, search) {
  const path = target.replace(/:([A-Za-z_]\w*)/g, (placeholder, name) => {
    const value = params && params[name];
    return value === undefined || value === null ? placeholder : encodeURIComponent(value);
  });

  const query = Object.keys(search || {})
    .filter((key) => search[key] !== undefined && search[key] !== null && search[key] !== '')
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(search[key])}`)
    .join('&');

  return query ? `${path}?${query}` : path;
}

/**
 * Обработчик перенаправления для $urlRouterProvider.when.
 *
 * ui-router вызывает обработчик через $injector.invoke, а приложение работает в
 * режиме ng-strict-di, поэтому функция передаётся с явной аннотацией зависимостей:
 * неаннотированная функция отвергается с ошибкой $injector:strictdi, и
 * перенаправление молча не выполняется.
 */
export function buildLegacyRedirect(target) {
  return [
    '$match',
    '$location',
    function redirectToNewUrl($match, $location) {
      return legacyRedirectTarget(target, $match, $location.search());
    },
  ];
}

/* @ngInject */
function configureLegacyRedirects($urlRouterProvider) {
  LEGACY_REDIRECTS.forEach(([from, to]) => $urlRouterProvider.when(from, buildLegacyRedirect(to)));
}

function isTransitionRequiresAuthentication(transition) {
  const UNAUTHENTICATED_ROUTES = ['shbdeployer.logout', 'shbdeployer.auth', 'shbdeployer.error'];
  if (!transition) {
    return true;
  }
  const nextTransition = transition && transition.to();
  const nextTransitionName = nextTransition ? nextTransition.name : '';
  return !UNAUTHENTICATED_ROUTES.some((route) => nextTransitionName.startsWith(route));
}
